module.exports = __webpack_public_path__ + "img/Support-skill-424.3db344b7.png";